import API from "shared/services/Api";
import { IDocumentation } from "shared/types/Documentation";

export const getDocuments = async (data: IDocumentation) =>
  API.get(`oc/documentation?id=${data.userId}&idPac=${data.idPac}`);
